import React from 'react';
import Logo from 'assets/img/Logo.svg';
import PropTypes from 'prop-types';

function ErrorView({ message }) {
  return (
    <div
      style={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '80vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img src={Logo} alt="logo" style={{ width: 180, marginBottom: '5em' }} />
      <h3>
        <b>{message || 'Error del servidor'}</b>
      </h3>
      {message && <h5>Contacta a un administrador.</h5>}
    </div>
  );
}

ErrorView.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorView;
